import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";
import { ArrowLeft, Building2 } from "lucide-react";

function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-primary/5 via-background to-primary/5 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="w-full max-w-md relative z-10">
        <Card className="border-2 shadow-2xl backdrop-blur-sm bg-background/95">
          <CardHeader className="text-center pb-8 pt-8">
            {/* Logo Section */}
            <div className="flex flex-col items-center gap-6 mb-6">
              <div className="flex items-center justify-center">
                <img
                  alt="Logo"
                  src={require("../../../assets/logo.png")}
                  className="h-20 w-auto object-contain"
                />
              </div>
              
              {/* 404 Number */}
              <div className="text-center">
                <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
                <CardTitle className="text-3xl font-bold text-foreground mb-2">
                  {t("gloabl.page_not_found") || "Page Not Found"}
                </CardTitle>
                <CardDescription className="text-base">
                  {t("gloabl.page_not_found_desc") || "The page you're looking for doesn't exist or has been moved."}
                </CardDescription>
              </div>
            </div>
          </CardHeader>

          <CardContent className="px-8 pb-8">
            <div className="flex flex-col gap-4">
              <Button
                onClick={() => navigate("/branches")}
                className="w-full h-12 text-base font-semibold gap-2"
                size="lg"
              >
                <Building2 className="w-5 h-5" />
                {t("gloabl.go_to_branches") || "Go to Branches"}
              </Button>
              
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                className="w-full h-12 text-base font-semibold gap-2"
                size="lg"
              >
                <ArrowLeft className="w-5 h-5" />
                {t("gloabl.go_back") || "Go Back"}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default NotFound;

